// extracted by mini-css-extract-plugin
export var cmtCardText = "styles-module--cmt-card-text--cedf3";
export var cmtCardText__container = "styles-module--cmt-card-text__container--7ac64";